/**
 * useWordCount — counts words in a string.
 * Import and call anywhere you need a live word count.
 */
export function countWords(str) {
  if (!str || !str.trim()) return 0
  return str.trim().split(/\s+/).length
}

export function useWordCount(text) {
  return countWords(text)
}
